module.exports = __webpack_public_path__ + "static/justin_osborne-db7752868524dfcf7df6dda384faa087.png";